import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import Name from '../Name/Name';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

// returns a Redux Form validation function
export const isValidLastName = (msg, griffinNameHandler) => (value) => {
    const name = {
        givenName: '',
        surname: value
    };
    if (griffinNameHandler.validateName(name, {field: 'surname'}).errors) {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class LastName extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        validations: PropTypes.arrayOf(PropTypes.func)
    };

    render() {
        const { intl, validations = [] } = this.props;

        return (
            <Name
                id="lastName"
                name="lastName"
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.lastname-label`})}
                validations={validations}
            />
        );
    }
}

export default injectIntl(LastName);
